module.exports = __webpack_public_path__ + "static/specSheet-96f3adca1cbfd6a2a464856619aa6293.svg";